import { render } from "./HeroSidebar.vue?vue&type=template&id=a278cdb2&scoped=true"
import script from "./HeroSidebar.vue?vue&type=script&lang=js"
export * from "./HeroSidebar.vue?vue&type=script&lang=js"

import "./HeroSidebar.vue?vue&type=style&index=0&id=a278cdb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a278cdb2"]])

export default __exports__